import { goToUaa, goToUaaFromMinerU } from '@/utils/getUAA';
import { message } from 'antd';
import type { AxiosError, InternalAxiosRequestConfig, AxiosResponse } from 'axios';
import axiosRequest from 'axios';
import { history } from '@umijs/max';
import { TOKEN_COOKIE_KEY } from '@/constant/storage';
import Cookies from 'js-cookie';

export const prefix = '/api';

const getConfig = (config: InternalAxiosRequestConfig) => {
  return config;
};

const axios = axiosRequest.create({
  timeout: 60 * 1000
  // cancelToken: new axios.CancelToken((cancel: Canceler) => {}),
});

const noLoginWhite = ['/application/status'];

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    return getConfig(config);
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

const originDataWhiteList = [
  '/datasets/api/v2/extract/task/submit',
  '/datasets/api/v2/extract/taskQueue',
  '/datasets/api/v2/extract/progress',
  '/datasets/api/v2/extract/list'
] as any[];

const loginWhiteList = ['/datasets/api/v2/extract/list', '/application/status'] as any[];

const responseSuccess = (res: AxiosResponse) => {
  // 获取文本内容
  if (originDataWhiteList?.some((i) => res?.config?.url?.includes(i))) {
    return res?.data;
  }
  if (res?.config?.responseType === 'text') {
    return res?.data;
  }
  return res?.data?.data;
};
const responseError = (error: AxiosError) => {
  const { response } = error;
  // console.log('test-response', response);
  // 去到登录页面
  switch (response?.status) {
    case 401:
      if (!loginWhiteList?.some((i) => response?.config?.url?.includes(i))) {
        if (response?.config?.url?.includes('/OpenSourceTools/Extractor/')) {
          goToUaaFromMinerU();
        } else {
          goToUaa();
        }
      } else {
        // 不跳转登录
      }
      break;
    case 403:
      history.push('/');
      break;
    case 429: // 请求过多
      history.push('/403');
      break;
  }
  // @ts-ignore
  const msg = response?.data?.msg || response?.statusText;
  if (!loginWhiteList?.some((i) => response?.config?.url?.includes(i))) {
    msg && message.error(msg);
  }
  return Promise.reject(error);
};

const requestIntercept = (config: InternalAxiosRequestConfig) => {
  const token = Cookies.get(TOKEN_COOKIE_KEY);
  console.log('test-token', token);
  // token鉴权的接口：带上headers，没有token则跳转去登录
  if (token) {
    if (config?.headers) {
      config.headers.Authorization = `Bearer ${Cookies.get(TOKEN_COOKIE_KEY)}`;
    }
  } else {
    // goLogin();
  }

  return config;
};

axios.interceptors.request.use(requestIntercept);

// 响应拦截器
axios.interceptors.response.use(responseSuccess, responseError);
export default axios;
